import { Mercor__Bids__BidItemRowControllerIdentifier } from "controllers/identifiers";
import BaseController from "confinus_ui/base_controller";
import BidItemRowController from "./bid_item_row_controller";

export default class BidDetailController extends BaseController {
  static outlets = [Mercor__Bids__BidItemRowControllerIdentifier];
  static targets = ["totalDisplay", "footerTotal"];

  declare totalDisplayTarget: HTMLElement;
  declare footerTotalTarget: HTMLElement;
  declare hasTotalDisplayTarget: boolean;
  declare hasFooterTotalTarget: boolean;

  // Outlet accessors - naming follows Stimulus convention: camelCase of the outlet identifier
  declare readonly mercorBidsBidItemRowOutlets: BidItemRowController[];
  private get itemRowControllers(): BidItemRowController[] {
    return this.mercorBidsBidItemRowOutlets;
  }

  static values = {
    maxDeviation: { type: Number, default: 0 },
    currencyCode: { type: String, default: "USD" },
  };

  declare maxDeviationValue: number;
  declare currencyCodeValue: string;

  private boundRecalculateTotal = this.recalculateTotal.bind(this);

  connect() {
    super.connect();
    this.recalculateTotal();
    this.element.addEventListener(
      "mercor--bids--bid-item-row:price-change",
      this.boundRecalculateTotal,
    );
  }

  disconnect() {
    this.element.removeEventListener(
      "mercor--bids--bid-item-row:price-change",
      this.boundRecalculateTotal,
    );
    super.disconnect();
  }

  recalculateTotal() {
    let total = 0;

    this.itemRowControllers.forEach((controller) => {
      if (controller.hasQuantityTarget && controller.hasProposedPriceTarget) {
        const qty = parseFloat(controller.quantityTarget.value) || 0;
        const price = parseFloat(controller.proposedPriceTarget.value) || 0;
        total += qty * price * 100;
      }
    });

    const formatted = this.formatCurrency(total);
    if (this.hasTotalDisplayTarget) {
      this.totalDisplayTarget.textContent = formatted;
    }
    if (this.hasFooterTotalTarget) {
      this.footerTotalTarget.textContent = formatted;
    }
  }

  private formatCurrency(cents: number): string {
    const dollars = cents / 100;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: this.currencyCodeValue,
    }).format(dollars);
  }
}
